function isMobileDevice() {
	const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isMobileScreen = window.innerWidth <= 400;
	return isMobileUserAgent || isMobileScreen;
}

function getDate(formatDate) {
	const today = new Date();
	const month = String(today.getMonth() + 1).padStart(2,'0');
	const date = String(today.getDate()).padStart(2,'0');
	const year = today.getFullYear();

	switch (formatDate) {
		case 'm/d/y':
			return `${month}/${date}/${year}`;
		case 'y/m/d':
			return `${year}/${month}/${date}`;
		case 'y-m-d':
			return `${year}-${month}-${date}`;
		default:
			return `${month}/${date}/${year}`;
	}
}

function fixDate(inputDate, formatDate) {
	const today = new Date(inputDate);
	const month = String(today.getMonth() + 1).padStart(2,'0');
	const date = String(today.getDate()).padStart(2,'0');
	const year = today.getFullYear();

	switch (formatDate) {
		case 'm/d/y':
			return `${month}/${date}/${year}`;
		case 'y/m/d':
			return `${year}/${month}/${date}`;
		case 'y-m-d':
			return `${year}-${month}-${date}`;
		default:
			return `${month}/${date}/${year}`;
	}
}

export {isMobileDevice, getDate, fixDate }